import { styled } from 'styled-components';
import { Card as CardType } from '@src/lib/types';

import { getCardImage } from '@src/lib/utils/card';

import cardBack from '@src/asset/img/card/card_back.jpg';
import { useEffect, useRef, useState } from 'react';
import { last } from 'lodash';

export const Container = styled.div`
  // position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  min-height: 25%;
  max-height: 45%;
  flex: 2;

  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
`;

export const NewCardImage = styled.img`
  position: absolute;
  // flex: 1;
  pointer-events: auto;
  cursor: pointer;

  // top: 0;

  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  
  // max-width: 160pt;
  min-width: 0;
  max-width: 18rem;
  top: 0;
  opacity: 1;
  align-self: center;
  @keyframes fromTop {
    0% { transform: translateY(-50%); opacity: 1; }
    100% { transform: translateY(50%); opacity: 0; transform : scale(0.9);}
  }

  // animation-timing-function: linear;
  // -webkit-animation-timing-function: linear;
  animation: fromTop 0.5s;
  -webkit-animation: fromTop 0.5s;
  z-index: 2;  
  box-shadow: -1pt 15pt 5pt 2pt rgba(0, 0, 0, 0.5);
  border-radius: 3pt;
`;

export const CardImage = styled.img`
  pointer-events: auto;
  cursor: pointer;

  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;

  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  min-width: 0;
  max-width: 20rem;

  max-height: 100%;

  box-shadow: -1pt 15pt 5pt 2pt rgba(0, 0, 0, 0.5);

  border-radius: 3pt;
`;

type Props = {
  card: CardType | null;
};

export default function Card(props: Props) {
  const [currentCardImage, setCurrentCardImage] = useState(
    props.card ? getCardImage(props.card) : cardBack,
  );
  const [newCardImage, setNewCardImage] = useState(null);
  const [showNewCardImage, setShowNewCardImage] = useState(false);

  useEffect(() => {
    setNewCardImage(props.card ? getCardImage(props.card) : cardBack);
    setShowNewCardImage(true);

    setTimeout(() => {
      setCurrentCardImage(props.card ? getCardImage(props.card) : cardBack);
      setShowNewCardImage(false);
    }, 300);
  }, [props.card]);

  return (
    <>
      <Container>
        {showNewCardImage && <NewCardImage src={newCardImage || cardBack} />}

        <CardImage src={currentCardImage} />
      </Container>
    </>
  );
}
